module.exports = __webpack_public_path__ + "static/img/rank_243.a14f02f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_243.png
// module id = uD/1
// module chunks = 1